import { Injectable }         from "@angular/core"
import { Router }             from "@angular/router"
import { logEvent }           from "firebase/analytics"
import { FirebaseService }    from "./firebase.service"

@Injectable({
  providedIn: "root",
})
export class LoggerService {
  constructor(
    private firebaseService : FirebaseService,
    private router          : Router,
  ) {}

  logToAnalytics = (eventName: string, optionalDetails?:any) => {
    const routes = this.router.url.split('/')
    const module = routes[routes.length-3]
    const page   = routes[routes.length-2]
    const tab    = routes[routes.length-1]
    optionalDetails = {...optionalDetails,module,page,tab}
    Object.keys(optionalDetails).forEach(key => optionalDetails[key] === undefined ? delete optionalDetails[key] : {})
    logEvent(this.firebaseService.analytics,eventName,optionalDetails)
  }

  logToAnalyticsNoRoute = (eventName: string, optionalDetails?:any) =>{
    logEvent(this.firebaseService.analytics,eventName,optionalDetails)
  }
}
